import React from "react";
import { evidenceList, evidenceMore, guidelineView, recordAria, recordText, recordTip } from "./sourceLinks";

/*
 * Source links of a recommendation (careiq.n3.2, CONTRACT §18), shown inside
 * the item's (i) popover (RecInfo.jsx; owner 10-06: links behind a tiny (i),
 * never on the card):
 *   Record(s)  the patient's own records, newest first ("LDL 162 mg/dL (H) ·
 *              Aug 12 Lipid Panel", "Renal ultrasound · Sep 19"), one per line,
 *              each opening the existing viewer in place: the lab popup of that
 *              date or the document viewer. "+N more" is grey.
 *   Guideline  "USPSTF May 2021 · Colorectal Cancer: Screening ↗", the vetted
 *              registry link, in a new tab (rel noopener).
 * No chips. An item with neither (every n3.1 body) renders nothing here.
 */

export function EvidenceLinks({ item, refYear, onOpen }) {
  const list = evidenceList(item, refYear);
  const more = evidenceMore(item);
  if (!list.length) return null;
  return (
    <>
      {list.map((r, i) => (
        <React.Fragment key={`${r.key}:${i}`}>
          {i > 0 ? <span className="n3-ref-sep" aria-hidden="true"> · </span> : null}
          <button
            type="button"
            className="n3-ref-lnk no-hover-tint"
            data-act="evidence"
            data-ev={r.kind}
            aria-label={recordAria(r)}
            title={recordTip(r)}
            onClick={() => onOpen && onOpen(r)}
          >
            {recordText(r)}
          </button>
        </React.Fragment>
      ))}
      {more > 0 ? <span className="n3-ref-more"><span className="n3-ref-sep" aria-hidden="true"> · </span>+{more} more</span> : null}
    </>
  );
}

export function GuidelineLink({ item }) {
  const g = guidelineView(item);
  if (!g) return null;
  return (
    <span className="n3-ref-g">
      <span className="n3-ref-k">{g.unverified ? "Source" : "Guideline"}</span>
      <a className="n3-ref-lnk n3-ref-ext" href={g.href} target="_blank" rel="noopener noreferrer" title={g.tip} data-act="guideline">
        <span className="n3-ref-gt">{g.label}{g.title ? ` · ${g.title}` : ""}</span>
        <span className="n3-ref-arrow" aria-hidden="true">↗</span>
        <span className="n3-sr"> (opens in a new tab)</span>
      </a>
    </span>
  );
}

// The links of one recommendation: its records, then its guideline. null when
// there is nothing to link.
export function RecRefs({ item, refYear, onOpenEvidence, className }) {
  const n = evidenceList(item, refYear).length;
  const hasG = Boolean(guidelineView(item));
  if (!n && !hasG) return null;
  return (
    <div className={className} data-refs={item.issue_key}>
      {n ? (
        <span className="n3-ref-ev">
          <span className="n3-ref-k">{n > 1 || evidenceMore(item) ? "Records" : "Record"}</span>
          <EvidenceLinks item={item} refYear={refYear} onOpen={onOpenEvidence} />
        </span>
      ) : null}
      {hasG ? <GuidelineLink item={item} /> : null}
    </div>
  );
}
